export default __webpack_public_path__ + "static/media/login-background.ffeee192.png";